// Which themes this build can wear. IMPROVEMENTS.md §7, after Crew Dispatch's src/lib/themes.ts.
//
// A theme is a stylesheet at frontend/public/themes/<slug>.css, linked AFTER the app's own CSS
// so its plain :root overrides win with no !important. It can change the product's shape —
// corner radius, border weight, shadow depth — as well as its neutrals, because those are
// tokens in styles.css rather than literals. The tenant's brand colours are not a theme's to
// set: Settings → Branding writes them inline on <html>, which outranks any stylesheet.
//
// In shared/ for the reason scope.js is: the server validates a stored slug against this list
// and the browser resolves one against it before building a URL, and two copies of a list of
// what may be fetched is two chances to disagree. No imports, no I/O — like scope.js, it must
// not be able to fail at load.
//
// ── The registry is empty, and that is the correct state ──────────────────────────────────
// The default look is the base token values themselves, and it loads no theme stylesheet at
// all. Nothing is registered until a customer actually needs to look different; authoring one
// to show the mechanism works would be a theme somebody then has to keep in step for nobody.
//
// ── The slug goes into a URL, so it is only ever used after being matched here ────────────
// A slug stored on a tenant, typed into the platform console or left over from a theme since
// removed is resolved through resolveThemeSlug first. An unknown one falls back to the default
// rather than fetching whatever path it spells. The list is fixed rather than a directory
// scan for the same reason: what may be fetched is decided in review, not by what is on disk.
//
// Adding one: copy frontend/public/themes/_template.css to <slug>.css, add { slug, name, note }
// below, then assign it to the tenant through the platform console (PATCH
// /api/platform/tenants/:id with { themeSlug }). frontend/tests/themes.test.js keeps the list
// and the files in step, in both directions.

/** @type {{ slug: string, name: string, note: string }[]} */
export const THEMES = []

/** What a slug may look like at all — lowercase words and hyphens, so it is a filename and nothing else. */
export const THEME_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/

export function isTheme(slug, registry = THEMES) {
  return typeof slug === 'string' && THEME_SLUG_PATTERN.test(slug) && registry.some((t) => t.slug === slug)
}

/** A registered slug, or null for the default look. The only safe input to a stylesheet URL. */
export function resolveThemeSlug(slug, registry = THEMES) {
  return isTheme(slug, registry) ? slug : null
}

/** The stylesheet to link for a slug, or null when the default look needs none. */
export function themeHref(slug, registry = THEMES) {
  const resolved = resolveThemeSlug(slug, registry)
  return resolved ? `/themes/${resolved}.css` : null
}
